import { useAuthenticationState } from '@solinkcorp/authentication';

const EN = {
  reloadPlayer: 'There was a problem playing the video, click here to reload.',
  tryingToLoad: 'We are trying to load the video resource... ',
  problemLoadingLocalAndCloud: 'We were unable to play video from the local device or cloud.',
  problemLoadingVideo: 'There was a problem loading the video resource from network [001]',
  problemLoadingResource: 'There was a problem loading the video resource from network [002]',
  cameraNotAccessible: "This camera isn't accessible right now.",
};

export type VideoTranslations = typeof EN;

const ES: VideoTranslations = {
  reloadPlayer:
    'Tuvimos un problema reproduciendo el video, haga clic aquí para intentar de nuevo.',
  tryingToLoad: 'Estamos tratando de cargar el video ',
  problemLoadingVideo: 'Tuvimos un problema cargando el video desde el origen[001]',
  problemLoadingLocalAndCloud: 'No pudimos reproducir video desde el dispositivo local o la nube.',
  problemLoadingResource: 'Tuvimos un problema cargando el video desde la red [002]',
  cameraNotAccessible: 'Esta cámara no está disponible en este momento.',
};

const FR: VideoTranslations = {
  reloadPlayer:
    'Un problème est survenu lors de la lecture de la vidéo, cliquez ici pour recharger',
  tryingToLoad: 'Nous essayons de charger la ressource vidéo... ',
  problemLoadingVideo:
    'Un problème est survenu lors du chargement de la ressource vidéo à partir du réseau. [001]',
  problemLoadingLocalAndCloud:
    "Impossible de lire la vidéo depuis l'appareil local ou depuis le cloud.",
  problemLoadingResource:
    'Un problème est survenu lors du chargement de la ressource vidéo à partir du réseau. [002]',
  cameraNotAccessible: "Cette caméra n'est pas accessible pour le moment.",
};

const TRANSLATIONS = {
  en: EN,
  fr: FR,
  es: ES,
};

export function getVideoTranslations(locale: string | undefined): VideoTranslations {
  const language = locale ? (locale.split('-')[0] as keyof typeof TRANSLATIONS) : 'en';
  return TRANSLATIONS[language] ?? TRANSLATIONS.en;
}

export function useVideoTranslations(): VideoTranslations {
  const [authState] = useAuthenticationState();
  const locale = authState.userSession?.profile.preferences?.locale;
  return getVideoTranslations(locale);
}
